export interface BlogCategory {
  name: string;
  slug: string;
  description: string;
}

export const BLOG_CATEGORIES: BlogCategory[] = [
  {
    name: 'Candidate Screening & Resume Screening',
    slug: 'candidate-screening',
    description: 'Best practices for screening candidates and leveraging AI-powered resume analysis to find top talent faster.',
  },
  {
    name: 'AI Interviews & Video Interviewing',
    slug: 'ai-interviews',
    description: 'Explore how AI-driven video interviews are transforming the way companies evaluate and hire candidates.',
  },
  {
    name: 'Structured Hiring & Interview Scorecards',
    slug: 'structured-hiring',
    description: 'Learn how structured interviews and scorecards reduce bias and improve hiring decisions.',
  },
  {
    name: 'Hiring Efficiency & Time-to-Hire',
    slug: 'hiring-efficiency',
    description: 'Strategies and tools to streamline your hiring pipeline and reduce time-to-hire without sacrificing quality.',
  },
  {
    name: 'Running a Recruitment Agency',
    slug: 'recruitment-agency',
    description: 'How staffing and recruitment agencies work, win clients, price their services and find candidates.',
  },
  {
    name: 'Responsible AI in Hiring',
    slug: 'responsible-ai',
    description: 'Insights on ethical AI use, bias mitigation, and building fair, transparent hiring processes.',
  },
];

export const CATEGORY_NAMES = BLOG_CATEGORIES.map(c => c.name);

export const slugToCategory = new Map(BLOG_CATEGORIES.map(c => [c.slug, c]));
export const nameToSlug = new Map(BLOG_CATEGORIES.map(c => [c.name, c.slug]));
